module.exports = __webpack_public_path__ + "img/trofeu_n.ad206f24.png";